// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getMergedAttributeTypeFacets,
    getProductsDataView,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import {
    AttributeTypeFacetModel,
    CategoryFacetModel,
    FacetModel,
    PriceFacetModel,
} from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { ProductListPageDataContext } from "@insite/content-library/Pages/ProductListPage";
import { formatPriceRangeFacet } from "@insite/content-library/Widgets/ProductList/ProductListPriceFilters";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
// import Tag, { TagPresentationProps } from "@insite/mobius/Tag"; // Starter Custom Code
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import FlexWrapper, { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import Options2Line from "@store/Library/Components/Toolkit/Icons/Options2/Options2Line";
import TagWrapper from "@store/Library/Components/Toolkit/TagWrapper";
import Tag, { TagPresentationProps } from "@store/MobiusOverrides/Tag/Tag";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { filtersProps } from "@store/Themes/common/props/filters";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";

const mobileHiddenStyles = () => css`
    ${breakpoint("sm", "down")} {
        display: none;
    }
`;
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    const {
        pages: {
            productList: { productFilters, unfilteredApiParameter, filteredApiParameter },
        },
        context: {
            session: { currency, language },
        },
    } = state;
    if (getProductListDataView(state).value) {
        const unfilteredDataView = getProductsDataView(state, unfilteredApiParameter);
        const unfilteredProductCollection = unfilteredDataView.value ? unfilteredDataView : undefined;

        const filteredDataView = getProductsDataView(state, filteredApiParameter);
        const filteredProductCollection = filteredDataView.value ? filteredDataView : undefined;

        return {
            loaded: true,
            stockedItemsOnly: productFilters.stockedItemsOnly ?? false,
            previouslyPurchasedProducts: productFilters.previouslyPurchasedProducts ?? false,
            brandFacets: unfilteredProductCollection?.brandFacets || filteredProductCollection?.brandFacets,
            productLineFacets:
                unfilteredProductCollection?.productLineFacets || filteredProductCollection?.productLineFacets,
            categoryFacets: unfilteredProductCollection?.categoryFacets,
            priceFacets:
                unfilteredProductCollection?.priceRange?.priceFacets ||
                filteredProductCollection?.priceRange?.priceFacets,
            attributeTypeFacets: getMergedAttributeTypeFacets(state, unfilteredApiParameter, filteredApiParameter),
            searchWithinQueries: productFilters.searchWithinQueries,
            selectedBrandIds: productFilters.brandIds,
            selectedProductLineIds: productFilters.productLineIds,
            selectedPriceFilters: productFilters.priceFilters,
            selectedAttributeValuesIds: productFilters.attributeValueIds,
            selectedCategoryId: productFilters.categoryId,
            currency,
            language,
        };
    }
    return {
        loaded: false,
        stockedItemsOnly: false,
        previouslyPurchasedProducts: false,
        brandFacets: [] as FacetModel[],
        productLineFacets: [] as FacetModel[],
        categoryFacets: [] as CategoryFacetModel[],
        priceFacets: [] as PriceFacetModel[],
        attributeTypeFacets: [] as AttributeTypeFacetModel[],
        searchWithinQueries: [] as string[],
        selectedBrandIds: [] as string[],
        selectedProductLineIds: [] as string[],
        selectedPriceFilters: [] as string[],
        selectedAttributeValuesIds: [] as string[],
        selectedCategoryId: "",
        currency: null,
        language: null,
    };
};

const mapDispatchToProps = {
    removeProductFilters,
    clearAllProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface ProductListFilterListStyles {
    wrapper?: InjectableCss;
    skipFiltersButtonWrapper?: InjectableCss;
    skipFiltersButton?: SkipNavStyles;
    filterText?: TypographyPresentationProps;
    filterTag?: TagPresentationProps;
    clearAllLink?: LinkPresentationProps;
    // Starter Custom Code
    filterTextIcon?: IconPresentationProps;
    selectionWrapper?: InjectableCss;
    selectionTitleWrapper?: FlexWrapperPresentationProps;
    selectionTitle?: TypographyPresentationProps;
}

export const filterListStyles: ProductListFilterListStyles = {
    wrapper: {
        css: css`
            ${spacingStyles(null, filtersProps.spacing)}
            position: relative;
        `,
    },
    filterText: {
        forwardAs: "h2",
        css: css`
            ${mobileHiddenStyles()}
            ${spacingStyles(null, filtersProps.spacing)}
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: ${filtersProps.borderCss};
            padding-bottom: ${pxToRem(14)};
            text-transform: uppercase;

            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.large};
                font-weight: ${theme.design.typography.weight.bold};
                line-height: ${theme.design.typography.lineHeight.small};
            `}
        `,
    },
    filterTextIcon: {
        src: Options2Line,
        css: css`
            margin-left: 0.5em;
        `,
    },
    skipFiltersButtonWrapper: {
        css: css`
            ${mobileHiddenStyles()}
            position: absolute;
            top: 0;
            width: 100%;
        `,
    },
    skipFiltersButton: {
        skipToContent: {
            sizeVariant: "small",
            css: css`
                position: absolute;
                top: 0;
                right: 0;
                margin: 0;
            `,
        },
    },
    clearAllLink: {
        css: linkActionStyles(),
    },
    selectionWrapper: filtersProps.flatSection,
    selectionTitleWrapper: {
        gap: pxToRem(6),
        extendedStyles: {
            content: {
                css: css`
                    ${filtersProps.title?.css}
                    justify-content: space-between;
                `,
            },
        },
    },
};

const styles = filterListStyles;

const ProductListFilterList: FC<Props> = ({
    loaded,
    stockedItemsOnly,
    previouslyPurchasedProducts,
    brandFacets,
    productLineFacets,
    priceFacets,
    categoryFacets,
    attributeTypeFacets,
    searchWithinQueries,
    selectedBrandIds,
    selectedProductLineIds,
    selectedPriceFilters,
    selectedAttributeValuesIds,
    selectedCategoryId,
    removeProductFilters,
    clearAllProductFilters,
    currency,
    language,
}) => {
    if (!loaded) {
        return null;
    }

    const clickRemoveStockedItemsOnly = () => {
        removeProductFilters({ stockedItemsOnly: false });
    };

    const clickRemovePreviouslyPurchasedProducts = () => {
        removeProductFilters({ previouslyPurchasedProducts: false });
    };

    const clickRemoveSearchHandler = (search: string) => {
        removeProductFilters({ searchWithinQueries: [search] });
    };

    const clickRemoveBrandHandler = (id: string) => {
        removeProductFilters({ brandIds: [id] });
    };

    const clickRemoveProductLineHandler = (id: string) => {
        removeProductFilters({ productLineIds: [id] });
    };

    const clickRemovePriceHandler = (price: string) => {
        removeProductFilters({ priceFilters: [price] });
    };

    const clickRemoveAttributeValueHandler = (id: string) => {
        removeProductFilters({ attributeValueIds: [id] });
    };

    const clickRemoveCategoryHandler = () => {
        removeProductFilters({ categoryId: selectedCategoryId });
    };

    const anyActiveFilters =
        searchWithinQueries?.length ||
        stockedItemsOnly ||
        previouslyPurchasedProducts ||
        (brandFacets && selectedBrandIds?.length) ||
        (productLineFacets && selectedProductLineIds?.length) ||
        (priceFacets && selectedPriceFilters?.length) ||
        (attributeTypeFacets && selectedAttributeValuesIds?.length) ||
        selectedCategoryId;

    /* Starter Custom Code - Start */
    const wrapperCss = css`
        ${() => (!anyActiveFilters ? mobileHiddenStyles() : null)}
        ${styles.wrapper?.css}
    `;

    const categoryValue =
        selectedCategoryId && categoryFacets?.find(o => o.categoryId === selectedCategoryId)?.shortDescription;

    const getTagDeleteButtonAccessibleText = (name?: string, value?: string) => {
        return name ? `${name}${value ? ` ${value}` : ""} ${translate("Filter")}` : undefined;
    };

    const previouslyPurchaseLabel = translate("Previously Purchased Only");
    const stockedItemsOnlyLabel = translate("Stocked Items Only");
    const searchLabel = translate("Search");
    const brandLabel = translate("Brand");
    const productLineLabel = translate("Product Line");
    const categoryLabel = translate("Category");
    const priceLabel = translate("Price");
    /* Starter Custom Code - End */

    return (
        <StyledWrapper {...styles.wrapper} css={wrapperCss /* Starter Custom Code */}>
            <Typography {...styles.filterText} data-test-selector="productListFilterList">
                {translate("Filters") /* Starter Custom Code */}
                <Icon {...styles.filterTextIcon /* Starter Custom Code */} />
            </Typography>
            <StyledWrapper {...styles.skipFiltersButtonWrapper}>
                <ProductListPageDataContext.Consumer>
                    {({ ref }) => {
                        return ref ? (
                            <SkipNav
                                text={translate("Skip to Results")}
                                extendedStyles={styles.skipFiltersButton}
                                destination={ref}
                            />
                        ) : undefined;
                    }}
                </ProductListPageDataContext.Consumer>
            </StyledWrapper>
            {/* Starter Custom Code - Start */}
            {anyActiveFilters ? (
                <StyledWrapper {...styles.selectionWrapper}>
                    <FlexWrapper {...styles.selectionTitleWrapper}>
                        <Typography {...styles.selectionTitle}>{translate("Selected Filter")}</Typography>
                        <Link
                            {...styles.clearAllLink}
                            onClick={() => clearAllProductFilters()}
                            data-test-selector="productListClearAll"
                        >
                            {translate("Clear All")}
                            <VisuallyHidden>{` ${translate("Filters")}`}</VisuallyHidden>
                        </Link>
                    </FlexWrapper>
                    <TagWrapper>
                        {previouslyPurchasedProducts && (
                            <Tag
                                {...styles.filterTag}
                                onDelete={clickRemovePreviouslyPurchasedProducts}
                                data-test-selector="previouslyPurchasedProductsFilter"
                                deleteButtonAccessibleText={getTagDeleteButtonAccessibleText(previouslyPurchaseLabel)}
                            >
                                {previouslyPurchaseLabel}
                            </Tag>
                        )}
                        {stockedItemsOnly && (
                            <Tag
                                {...styles.filterTag}
                                onDelete={clickRemoveStockedItemsOnly}
                                data-test-selector="stockedItemsOnlyFilter"
                                deleteButtonAccessibleText={getTagDeleteButtonAccessibleText(stockedItemsOnlyLabel)}
                            >
                                {stockedItemsOnlyLabel}
                            </Tag>
                        )}
                        {searchWithinQueries?.map(s => (
                            <Tag
                                key={s}
                                {...styles.filterTag}
                                onDelete={() => clickRemoveSearchHandler(s)}
                                data-test-selector="searchWithinFilter"
                                deleteButtonAccessibleText={getTagDeleteButtonAccessibleText(searchLabel, s)}
                            >
                                {searchLabel}: {s}
                            </Tag>
                        ))}
                        {brandFacets &&
                            selectedBrandIds?.map(id => {
                                const brandValue = brandFacets?.find(o => o.id === id)?.name;
                                return (
                                    <Tag
                                        key={id}
                                        {...styles.filterTag}
                                        onDelete={() => clickRemoveBrandHandler(id)}
                                        data-test-selector={`brandFilter${id}`}
                                        deleteButtonAccessibleText={getTagDeleteButtonAccessibleText(
                                            brandLabel,
                                            brandValue,
                                        )}
                                    >
                                        {brandLabel}: {brandValue}
                                    </Tag>
                                );
                            })}
                        {productLineFacets &&
                            selectedProductLineIds?.map(id => {
                                const productLineValue = productLineFacets?.find(o => o.id === id)?.name;
                                return (
                                    <Tag
                                        key={id}
                                        {...styles.filterTag}
                                        onDelete={() => clickRemoveProductLineHandler(id)}
                                        data-test-selector={`productLineFilter${id}`}
                                        deleteButtonAccessibleText={getTagDeleteButtonAccessibleText(
                                            productLineLabel,
                                            productLineValue,
                                        )}
                                    >
                                        {productLineLabel}: {productLineValue}
                                    </Tag>
                                );
                            })}
                        {selectedCategoryId && (
                            <Tag
                                {...styles.filterTag}
                                onDelete={() => clickRemoveCategoryHandler()}
                                data-test-selector={`categoryFilter${selectedCategoryId}`}
                                deleteButtonAccessibleText={getTagDeleteButtonAccessibleText(
                                    categoryLabel,
                                    categoryValue,
                                )}
                            >
                                {categoryLabel}: {categoryValue}
                            </Tag>
                        )}
                        {priceFacets &&
                            selectedPriceFilters?.map(id => {
                                const priceValue = formatPriceRangeFacet(
                                    priceFacets?.find(o => o.minimumPrice.toString() === id),
                                    currency,
                                    language,
                                );
                                return (
                                    <Tag
                                        key={id}
                                        {...styles.filterTag}
                                        onDelete={() => clickRemovePriceHandler(id)}
                                        data-test-selector={`priceFilter${id}`}
                                        deleteButtonAccessibleText={getTagDeleteButtonAccessibleText(
                                            priceLabel,
                                            priceValue,
                                        )}
                                    >
                                        {priceLabel}: {priceValue}
                                    </Tag>
                                );
                            })}
                        {attributeTypeFacets &&
                            selectedAttributeValuesIds?.map(id => {
                                const attributeTypeFacet = attributeTypeFacets?.find(at =>
                                    at.attributeValueFacets?.find(av => av.attributeValueId === id),
                                );
                                const attributeValueFacet = attributeTypeFacet?.attributeValueFacets?.find(
                                    av => av.attributeValueId === id,
                                );

                                return (
                                    <Tag
                                        key={id}
                                        {...styles.filterTag}
                                        onDelete={() => clickRemoveAttributeValueHandler(id)}
                                        data-test-selector={`attributeValueFilter${id}`}
                                        deleteButtonAccessibleText={getTagDeleteButtonAccessibleText(
                                            attributeTypeFacet?.nameDisplay,
                                            attributeValueFacet?.valueDisplay,
                                        )}
                                    >
                                        {attributeTypeFacet?.nameDisplay}: {attributeValueFacet?.valueDisplay}
                                    </Tag>
                                );
                            })}
                    </TagWrapper>
                </StyledWrapper>
            ) : null}
            {/* Starter Custom Code - End */}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListFilterList),
    definition: {
        group: "Product List",
        displayName: "Filter List",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
